import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

import Table from 'components/table/SimpleTable'

import routerActions from 'store/modules/router'
import bookActions from 'store/modules/booking'
import bookSelectors from 'store/selectors/booking'
import projectSelectors from 'store/selectors/project'
import bookingformSelectors from 'store/selectors/bookingform'

import {
  projectUrl,
  bookingFormUrl,
  fullUrl,
} from 'utils/url'

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
  },
  title: {
    flexGrow: 1,
  },
  addButton: {
    flexGrow: 0,
  },
  actionButton: {
    margin: theme.spacing(1),
  }
}))

const FIELDS = [{
  title: 'Name',
  name: 'name',
}, {
  title: 'URL',
  name: 'url',
}, {
  title: 'Description',
  name: 'description',
}]

const BookingForms = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  
  const project = useSelector(projectSelectors.currentProject)
  const bookingforms = useSelector(bookingformSelectors.bookingForms)

  const onView = useCallback((bookingform) => {
    dispatch(routerActions.navigateTo('book.form.calendar', {
      project: projectUrl(project),
      bookingform: bookingFormUrl(bookingform),
      date: 'today',
    }))
  }, [
    project,
  ])

  const tableData = useMemo(() => {
    return bookingforms.map(bookingform => {
      const url = fullUrl(project, bookingform)
      return {
        id: bookingform.id,
        name: bookingform.name,
        bookingform,
        description: (
          <Typography variant="caption" className={ classes.description }>
            { bookingform.meta.description }
          </Typography>
        ),
        url: (
          <a
            href={ url }
            onClick={ (e) => {
              e.preventDefault()
              onView(bookingform)
            }}
          >
            { url }
          </a>
        )
      }
    })
  }, [
    bookingforms,
  ])

  const getActions = useCallback((item) => {
    return (
      <>
        <Button
          className={ classes.actionButton }
          size="small"
          variant="outlined"
          onClick={ (e) => {
            onView(item.bookingform)
            return false
          }}
        >
          Book
        </Button>
      </>
    )
  })

  return (
    <div className={ classes.root }>
      <div className={ classes.toolbar }>
        <div className={ classes.title }>
          <Typography gutterBottom variant="h6">
            Booking Forms
          </Typography>
        </div>
      </div>
      <div className={ classes.content }>
        <Table
          data={ tableData }
          fields={ FIELDS }
          getActions={ getActions }
        />
      </div>
    </div>
  )
}

export default BookingForms